export const OFFERS_LISTING_URL_EVENT = "offersListing:urlchange";
const PAGINATION_PARAMS = ["page", "per-page"];
function normalizePath(pathAndQuery) {
    const raw = pathAndQuery !== null && pathAndQuery !== void 0 ? pathAndQuery : window.location.pathname + window.location.search;
    const url = new URL(raw.startsWith("/") ? raw : `/${raw}`, window.location.origin);
    if (url.origin !== window.location.origin) {
        return window.location.pathname;
    }
    PAGINATION_PARAMS.forEach((name) => url.searchParams.delete(name));
    const search = url.searchParams.toString();
    return url.pathname + (search ? `?${search}` : "");
}
function buildUrlDetails(value) {
    var _a;
    return {
        value,
        path: (_a = value.split("?")[0]) !== null && _a !== void 0 ? _a : value,
        search: window.location.search,
    };
}
export function getListingLocation() {
    return {
        pathname: window.location.pathname,
        search: window.location.search,
    };
}
export function navigateToListingUrl(pathAndQuery) {
    var _a;
    const target = normalizePath(pathAndQuery);
    const current = normalizePath();
    if (target === current) {
        return;
    }
    // No full-page fallback: assigning window.location from derived data is an
    // open-redirect sink, and pushState is supported by every browser we serve.
    if (typeof ((_a = window.history) === null || _a === void 0 ? void 0 : _a.pushState) !== "function") {
        return;
    }
    window.history.pushState({ offersListing: true }, "", target);
    document.dispatchEvent(new CustomEvent(OFFERS_LISTING_URL_EVENT, {
        detail: buildUrlDetails(target),
    }));
}
